'use client';

// P29.3 / Q7: framer-motion provider for marketing pages. Uses LazyMotion +
// domAnimation features bundle to keep the bundle minimal — components import
// `m` instead of `motion` and only the loaded features ship.

import { LazyMotion, domAnimation } from 'framer-motion';
import type { ReactNode } from 'react';

export function LazyMotionProvider({ children }: { children: ReactNode }) {
  return <LazyMotion features={domAnimation}>{children}</LazyMotion>;
}
